module.exports = __webpack_public_path__ + "img/would_get_vaccinated.f50f2911.svg";